import requestService from "./requestService"
import { paymentStore } from "@/store/paymentStore"

export default {
    setPayment(payment) {
        localStorage.setItem('payment', JSON.stringify({
            payment_method: payment.payment_method,
            total: payment.total + '00'
        }))
    },
    async paymentCreditCard(data) {
        return await requestService.post('/customer-payments/create', {
            method: 'credit_card',
            ...data
        })
    },
    setPaymentData(data) {
        const store = paymentStore()
        store.setPaymentData(data)
    },
    getPaymentMethod() {
        let method = JSON.parse(localStorage.getItem('payment'))
        return method ? method.payment_method : null
    },
    getPaymentData() {
        const store = paymentStore()
        return store.paymentData
    },
    deletePaymentData() {
        const store = paymentStore()
        store.removePaymentData()
    },
    async checkPayment(type, payment_checker) {
        return await requestService.get('/customer-payments/check-payment', {
            type: type,
            payment_checker: payment_checker
        })
    }
}